// Hợp đồng KHỐI NỘI DUNG (block contract) giữa AI ↔ renderer ↔ trình biên tập.
// Mọi khối AI sinh ra phải thuộc tập loại dưới đây để import được vào bài giảng và render
// đúng bằng ContentRenderer / InteractiveContentRenderer.
import SimulationLibrary from '../../../services/simulation/SimulationLibrary'

export interface LessonContext { lop?: number; chuong?: number; bai?: number }

const num = (s?: string | number): number | undefined => {
  if (s === undefined || s === null) return undefined
  const m = String(s).match(/\d+/); return m ? Number(m[0]) : undefined
}
export function lessonCtx(meta: { lop?: string; chuong?: string; bai?: string }): LessonContext {
  return { lop: num(meta.lop), chuong: num(meta.chuong), bai: num(meta.bai) }
}

// Loại khối trình bày (ContentRenderer) + câu hỏi/tương tác (InteractiveContentRenderer).
export const PRESENTATION_TYPES = ['heading', 'text', 'formula', 'list', 'table', 'image', 'concept_card', 'example', 'warning', 'conclusion_card', 'formula_card']
export const QUESTION_TYPES = ['quiz', 'interactive_question', 'multiple_choice', 'true_false', 'short_answer', 'sequence_question', 'multiple_response_question']
const KNOWN = new Set([...PRESENTATION_TYPES, ...QUESTION_TYPES])

// Đặc tả cho prompt AI (đồng bộ với backend) — tài liệu hoá hợp đồng.
export const PROMPT_BLOCK_SPEC = `Các loại khối hợp lệ (TUÂN THỦ tên trường):
- heading: {type, level:2|3, content}
- text: {type, content}  // markdown + công thức $...$ / $$...$$ ; giữ [HÌNH n]
- formula: {type, content:"<LaTeX>", explanation?, display?:true}
- list: {type, style:"bullet"|"numbered", items:[string]}
- table: {type, title?, headers:[string], rows:[[string]]}
- concept_card: {type, title, content, icon?, color?}   // thẻ kiến thức trọng tâm
- example: {type, title, content, icon?, color?}         // ví dụ minh hoạ
- warning: {type, title?, content}                       // lưu ý/cảnh báo
- conclusion_card: {type, title?, content}               // tổng kết
- formula_card: {type, title?, content}                  // khung công thức
- interactive_question: {type, question, options:[string], correctAnswer:<index>, explanation?, hint?, difficulty?:"easy"|"medium"|"hard"}
- multiple_response_question: {type, question, options:[string], correctAnswers:[index], explanation?, hint?, difficulty?}
- sequence_question: {type, question, items:[string], correctSequence:[index], explanation?, hint?}
- quiz: {type, title, questions:[ multiple_choice|true_false|fill_blank ]}
- simulation_ref: {type, note?}  // ĐỀ XUẤT chèn mô phỏng của bài (Lớp/Chương/Bài) — hệ thống tự map`

// Resolve khối simulation_ref → khối mô phỏng thật theo (lop,chuong,bai) — KHÔNG để AI bịa.
function resolveSims(ctx: LessonContext): any[] {
  if (ctx.lop == null || ctx.chuong == null || ctx.bai == null) return []
  try {
    // Lab được gắn thành THẺ riêng (lab card) → loại khỏi inline để không trùng.
    const sims = SimulationLibrary.getSimsByLesson(ctx.lop, ctx.chuong, ctx.bai).filter((s) => s.kind !== 'lab')
    return sims.slice(0, 1).map((s) => SimulationLibrary.toContentBlock(s))
  } catch { return [] }
}

/** Chuẩn hoá danh sách khối AI → khối tương thích renderer (bỏ khối sai, map field). */
export function normalizeBlocks(items: any[], ctx: LessonContext): any[] {
  if (!Array.isArray(items)) return []
  const out: any[] = []
  for (const it of items) {
    if (!it || typeof it !== 'object' || typeof it.type !== 'string') continue
    const t = it.type
    if (t === 'simulation_ref') { out.push(...resolveSims(ctx)); continue }
    if (t === 'image') { const src = it.src || it.content; if (src) out.push({ ...it, type: 'image', src }); continue }
    if (t === 'heading') { out.push({ ...it, level: it.level === 3 ? 3 : 2 }); continue }
    if (KNOWN.has(t)) { out.push(it); continue }
    // khối lạ: nếu có content/question thì hạ về text để không mất nội dung
    if (typeof it.content === 'string') out.push({ type: 'text', content: it.content })
  }
  return out
}
